// extracted by mini-css-extract-plugin
var _1 = "Checked-Day6u";
var _2 = "FancyCheckbox-uVgfU";
var _3 = "Lever-minH2";
export { _1 as "Checked", _2 as "FancyCheckbox", _3 as "Lever" }
